import { Toaster as SonnerToaster } from 'sonner';

import { TOAST_DURATION } from './notifications';

export const Toaster = () => (
  <SonnerToaster
    duration={TOAST_DURATION}
    gap={8}
    position="top-right"
    toastOptions={{ unstyled: true, classNames: { toast: 'w-full' } }}
  />
);
